import { styled } from '@linaria/react';

export const ReviewsPageWrapper = styled.div`
  margin-bottom: 5rem;
`;
